import { useListContext, useLocaleState, type Identifier } from "ra-core";
import { useState } from "react";
import { cn } from "@/lib/utils";

import type { CrmEvent } from "../types";
import { EventEditDialog } from "./EventDialogs";
import { useEventTypeLookup } from "./eventTypes";
import { formatEventDate } from "./formatEvent";

/** Events of a company or contact page; a click opens the event. Past ones are muted. */
export const EventsIterator = () => {
  const { data, isPending } = useListContext<CrmEvent>();
  const [locale = "fr"] = useLocaleState();
  const lookupType = useEventTypeLookup();
  const [selectedId, setSelectedId] = useState<Identifier | null>(null);
  if (isPending || !data?.length) return null;
  const now = new Date();

  return (
    <>
      <ul className="flex flex-col gap-1">
        {data.map((event) => {
          const type = lookupType(event.type);
          const isPast = new Date(event.end_at ?? event.start_at) < now;
          return (
            <li key={event.id}>
              <button
                type="button"
                onClick={() => setSelectedId(event.id)}
                className="w-full text-left rounded-md px-1 -mx-1 py-1 hover:bg-muted flex gap-2 items-start cursor-pointer"
              >
                <span
                  className="mt-1.5 size-2 rounded-full shrink-0"
                  style={{ backgroundColor: type.color }}
                />
                <span className="flex flex-col min-w-0">
                  <span
                    className={cn(
                      "text-sm truncate",
                      isPast && "text-muted-foreground",
                    )}
                  >
                    {event.name}
                  </span>
                  <span className="text-xs text-muted-foreground">
                    {formatEventDate(event, locale)}
                    {type.label ? ` · ${type.label}` : ""}
                  </span>
                </span>
              </button>
            </li>
          );
        })}
      </ul>
      <EventEditDialog
        eventId={selectedId}
        onClose={() => setSelectedId(null)}
      />
    </>
  );
};
